import { createFileRoute } from "@tanstack/react-router";

import { IntegrationRoutesPage } from "../../pages/settings/IntegrationRoutes.page";

// `settings_` keeps this route out of the `/settings` layout (see the
// Integration Keys route beside it).
export const Route = createFileRoute("/_protected/settings_/integration-routes")({
  component: IntegrationRoutesPage,
});
